import React from 'react';
import { diagnosticFlow } from '../data/content';
export function SystemOverview() {
  return <section className="bg-navy px-3 py-4 text-white sm:px-6" data-id="element-150" data-mp="18vski2oh9av8">
      <div className="mx-auto max-w-2xl text-center" data-id="element-151" data-mp="18tg43tydb8ka">
        <h2 className="font-display text-[1.35rem] font-extrabold uppercase leading-none sm:text-[1.85rem]" data-id="element-152" data-mp="1mlm8kis5rr3w">
          EVERYTHING YOU NEED.{' '}
          <span className="text-aqua" data-id="element-153" data-mp="1hpx6o8so1y4f">ONE COMPLETE POOL &amp; SPA DIAGNOSTIC SYSTEM.</span>
        </h2>
        <p className="mt-1 text-[0.78rem] font-semibold text-white/80 sm:text-[0.92rem]" data-id="element-154" data-mp="tztb8opmt4oi">
          6 Professional Troubleshooting &amp; Repair Resources In One Organized System
        </p>
        <p className="mt-2 font-display text-[1.05rem] font-extrabold uppercase text-sun sm:text-[1.3rem]" data-id="element-155" data-mp="13u392lxcev6m">
          🏊 POOL &amp; SPA DIAGNOSTIC PRO™
        </p>
        <p className="mt-1 text-[0.78rem] leading-[1.4] text-white/85 sm:text-[0.92rem]" data-id="element-156" data-mp="2fa1jou865p9y">
          POOL &amp; SPA DIAGNOSTIC PRO™ brings equipment identification, pump and motor troubleshooting,
          filtration and water quality diagnostics, heating system assessment, electrical controls, spa
          equipment fault identification and complete repair workflows together in one organized
          professional system.
        </p>
        <p className="mt-2 inline-block rounded-md border border-aqua/60 bg-navy-soft px-2.5 py-1 font-display text-[0.56rem] font-extrabold uppercase text-white sm:text-[0.8rem]" data-id="element-157" data-mp="2d2pk7scnrbms">
          {diagnosticFlow.map((step, i) => <React.Fragment key={step} data-id="element-158" data-mp="1peg3h4uaxe2i" data-mpi={i}>
              {i > 0 ? <span className="text-aqua" data-id="element-159" data-mp="1pf8zpbvmwl6e"> → </span> : null}
              {step}
            </React.Fragment>)}
        </p>
      </div>
    </section>;
}